import "../index.css";
import React, { useState, useEffect } from "react";
import MyResume from "../assets/Pravesh's Resume.pdf";
import { Document, Page, pdfjs } from "react-pdf";
import { IonIcon } from "@ionic/react";
import { downloadOutline } from "ionicons/icons";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function Resume({ isActive }) {
  const [width, setWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <article
      className={isActive ? "contact active" : "contact"}
      data-page="contact"
    >
      {/* DOWNLOAD BUTTON */}
      <div className="resume-header">
        <a
          href={MyResume}
          target="_blank"
          rel="noreferrer"
          className="download-btn"
        >
          <IonIcon icon={downloadOutline} />
          <span>Download Resume</span>
        </a>
      </div>

      {/* PDF VIEW */}
      <div className="resume-viewer">
        <Document file={MyResume}>
          <Page
            pageNumber={1}
            scale={width > 768 ? 1.3 : 0.6}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        </Document>
      </div>
    </article>
  );
}

export default Resume;